import { Http } from "@shared/svelte/Modules/ApiService";
import type { HTTPParams } from "@shared/types/HTTP";
import { pickupWarehousesStore } from "@retailer/svelte/stores/PickupWarehousesStore"

const makeReq = async (requestData: any, successCB: any) => {
  const errCB = () => {
    pickupWarehousesStore.update((previousState) => ({
      ...previousState,
      loaded: true,
      failed: true,
    }));
  };

  pickupWarehousesStore.update((previousState) => ({
    ...previousState,
    loaded: false,
    failed: false,
  }));

  await Http(requestData, successCB, errCB)
}

export const get = async (productId: number, distributorId: number) => {
  const requestData: HTTPParams = {
    method: "GET",
    url: `/api/retailer/products/${productId}/pickup_warehouses`,
    data: {
      distributor_id: distributorId
    }
  };

  const successCB = (json: any) => {
    pickupWarehousesStore.set({
      loaded: true,
      failed: false,
      pickupWarehouses: json
    })
  };

  makeReq(requestData, successCB)
};
